import { createSelector } from 'reselect'
import { AppStateType } from '../reducers'
import { IPublishedSearch } from '../types/publishedSearch'

export const selectPublishedSearch = ({ publishedSearch }: AppStateType): IPublishedSearch => publishedSearch

export const selectItems = createSelector(
  selectPublishedSearch,
  ({ items }: IPublishedSearch): any[] => items
)

export const selectSkipQuery = createSelector(
  selectPublishedSearch,
  ({ skip }: IPublishedSearch): number => skip
)
